<div class="error-page-container">
    <div class="error-page-content">

        <lib-no-data [message]="message" [description]="description" [icon]="icon"
            data-testid="error-page-content">
            <div class="actions">
                <lib-button color="outline" (click)="goHome()" text="Retour à l'accueil" icon="home"></lib-button>

                <lib-button color="outline" (click)="goBack()" text="Retour" icon="arrow_back"></lib-button>
            </div>
        </lib-no-data>
    </div>
</div>
